import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuthStore } from '../store/adminAuthStore';
import { canAccessHierarchyBuilder, firstAdminPath } from '../config/permissions.config';

interface AdminHierarchyGuardProps {
  children: React.ReactNode;
}

/** Passes when the admin may open Hierarchy Builder (`manage_nodes` or any template view). */
export const AdminHierarchyGuard: React.FC<AdminHierarchyGuardProps> = ({ children }) => {
  const { has, admin } = useAdminAuthStore();
  const permissions = admin?.permissions ?? [];

  if (canAccessHierarchyBuilder(permissions, has)) {
    return <>{children}</>;
  }

  const fallback = firstAdminPath(has, permissions);
  return <Navigate to={fallback ?? '/admin/forbidden'} replace />;
};

export default AdminHierarchyGuard;
